import React from 'react';
import { ShieldCheck, Lock, CreditCard } from 'lucide-react';
export function TrustSection() {
  return <section id="trust" className="py-24 bg-dark-900 border-t border-white/5" data-id="element-193">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-194">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-195">
          {/* Left Content */}
          <div data-id="element-196">
            <h2 className="text-3xl md:text-5xl font-serif font-bold text-white mb-6 leading-tight" data-id="element-197">
              安全可靠，
              <br data-id="element-198" />
              <span className="text-gold-500" data-id="element-199">值得信赖</span>
            </h2>
            <p className="text-gray-400 text-lg mb-8 leading-relaxed" data-id="element-200">
              IsYou
              致力于为您提供最安全、最私密的高端伴游服务。我们深知隐私与安全的重要性，因此建立了严格的审核与保障机制。
            </p>

            <div className="space-y-6" data-id="element-201">
              <div className="flex items-start" data-id="element-202">
                <div className="flex-shrink-0 mt-1" data-id="element-203">
                  <ShieldCheck className="w-6 h-6 text-gold-500" data-id="element-204" />
                </div>
                <div className="ml-4" data-id="element-205">
                  <h4 className="text-lg font-bold text-white" data-id="element-206">真人核验</h4>
                  <p className="text-gray-400 text-sm mt-1" data-id="element-207">
                    所有伴游女郎均经过严格的身份核验和线下面试，杜绝照骗。
                  </p>
                </div>
              </div>

              <div className="flex items-start" data-id="element-208">
                <div className="flex-shrink-0 mt-1" data-id="element-209">
                  <Lock className="w-6 h-6 text-gold-500" data-id="element-210" />
                </div>
                <div className="ml-4" data-id="element-211">
                  <h4 className="text-lg font-bold text-white" data-id="element-212">隐私保护</h4>
                  <p className="text-gray-400 text-sm mt-1" data-id="element-213">
                    采用端到端加密技术，严格保护您的个人信息与行程隐私。
                  </p>
                </div>
              </div>

              <div className="flex items-start" data-id="element-214">
                <div className="flex-shrink-0 mt-1" data-id="element-215">
                  <CreditCard className="w-6 h-6 text-gold-500" data-id="element-216" />
                </div>
                <div className="ml-4" data-id="element-217">
                  <h4 className="text-lg font-bold text-white" data-id="element-218">满意付款</h4>
                  <p className="text-gray-400 text-sm mt-1" data-id="element-219">
                    见面满意后付款，不满意可随时取消，资金安全有保障。
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Right Image/Graphic */}
          <div className="relative" data-id="element-220">
            <div className="absolute inset-0 bg-gold-500/20 blur-[100px] rounded-full" data-id="element-221"></div>
            <div className="relative bg-dark-800 border border-white/10 rounded-2xl p-8 md:p-12" data-id="element-222">
              <div className="text-center mb-8" data-id="element-223">
                <div className="text-6xl font-serif font-bold text-gold-500 mb-2" data-id="element-224">
                  100%
                </div>
                <div className="text-white text-lg" data-id="element-225">客户满意度</div>
              </div>
              <div className="space-y-4" data-id="element-226">
                <div className="bg-dark-900 p-4 rounded border border-white/5 flex items-center" data-id="element-227">
                  <div className="w-10 h-10 rounded-full bg-gray-700 flex-shrink-0 mr-4" data-id="element-228"></div>
                  <div data-id="element-229">
                    <div className="w-24 h-2 bg-gray-700 rounded mb-2" data-id="element-230"></div>
                    <div className="w-48 h-2 bg-gray-800 rounded" data-id="element-231"></div>
                  </div>
                </div>
                <div className="bg-dark-900 p-4 rounded border border-white/5 flex items-center opacity-70" data-id="element-232">
                  <div className="w-10 h-10 rounded-full bg-gray-700 flex-shrink-0 mr-4" data-id="element-233"></div>
                  <div data-id="element-234">
                    <div className="w-24 h-2 bg-gray-700 rounded mb-2" data-id="element-235"></div>
                    <div className="w-48 h-2 bg-gray-800 rounded" data-id="element-236"></div>
                  </div>
                </div>
                <div className="bg-dark-900 p-4 rounded border border-white/5 flex items-center opacity-40" data-id="element-237">
                  <div className="w-10 h-10 rounded-full bg-gray-700 flex-shrink-0 mr-4" data-id="element-238"></div>
                  <div data-id="element-239">
                    <div className="w-24 h-2 bg-gray-700 rounded mb-2" data-id="element-240"></div>
                    <div className="w-48 h-2 bg-gray-800 rounded" data-id="element-241"></div>
                  </div>
                </div>
              </div>
              <div className="mt-8 text-center" data-id="element-242">
                <button className="text-gold-500 text-sm hover:text-white transition-colors" data-id="element-243">
                  查看客户评价 &rarr;
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}